export enum DataSyncProvidersEnum {
	Quba = "Quba",
}

export enum DataSyncEntityType {
	Clients = 1,
	Candidates = 2,
	Bookings = 3,
}
